<template>
  <div class="settings-view">
    <div class="menu-settings">
      <strong>Общие настройки по проекту</strong>
      <div class="edit-ul">
        <div class="edit-li">
          <router-link to="/dashboard/users" class="link-cont">
            <span>
              Пользователи
            </span>
            <i class="fas fa-chevron-right"></i>
          </router-link>
        </div>
        <div class="edit-li">
          <div class="help-container">
            <el-popover
              placement="top-start"
              title=""
              width="200"
              trigger="click"
              content="Проекты могут включать несколько объектов. Это могут быть: секции, этажи, блоки, титулы, или разделы рабочей документации (КМ, КЖ и т.д.). Можно задать любую иерархию объектов и привязать свой перечень работ к каждому объекту, нажав (символ «колесико»).">
              <i slot="reference" class="el-icon-question"/>
            </el-popover>
          </div>
          <router-link to="/dashboard/objects" class="link-cont">
            <span>
              Объекты
            </span>
            <i class="fas fa-chevron-right"></i>
          </router-link>
        </div>
        <div class="edit-li">
          <div class="help-container">
            <el-popover
              placement="top-start"
              title=""
              width="200"
              trigger="click"
              content="Создайте «Виды работ» и привяжите их при создании работы в разделе «Работы». Это объединит однотипные работы в единую категорию и позволит получать Аналитику план-факт по видам работ в «Сводке по видам работ». ">
              <i slot="reference" class="el-icon-question"/>
            </el-popover>
          </div>
          <router-link to="/dashboard/works/list" class="link-cont">
            <span>
              Виды работ
            </span>
            <i class="fas fa-chevron-right"></i>
          </router-link>
        </div>

        <div class="edit-li">
          <div class="help-container">
            <el-popover
              placement="top-start"
              title=""
              width="200"
              trigger="click"
              content="Создайте работы с указанием ед. измерения, плана и вида работ (если необходимо) или загрузите работы из Excel. Если вы используете объекты, удобно создавать или загружать работы прямо из справочника «Объекты», нажав (символ колесико) напротив соответствующего объекта.">
              <i slot="reference" class="el-icon-question"/>
            </el-popover>
          </div>
          <router-link to="/dashboard/jobs" class="link-cont">
            <span>
              Работы
            </span>
            <i class="fas fa-chevron-right"></i>
          </router-link>
        </div>

        <div class="edit-li">
          <div class="help-container">
            <el-popover
              placement="top-start"
              title=""
              width="200"
              trigger="click"
              content="Создайте перечень профессии для отчетов по численности. Кроме количественного учета можно добавить учет по часам, поставив галочку «Учет по часам».">
              <i slot="reference" class="el-icon-question"/>
            </el-popover>
          </div>
          <router-link to="/dashboard/prof" class="link-cont">
            <span>
              Профессии
            </span>
            <i class="fas fa-chevron-right"></i>
          </router-link>
        </div>

        <div class="edit-li">
          <div class="help-container">
            <el-popover
              placement="top-start"
              title=""
              width="200"
              trigger="click"
              content="Создайте перечень техники, механизмов или оборудования для отчетов по технике. Кроме количественного учета можно добавить учет по часам, поставив галочку «Учет по часам».">
              <i slot="reference" class="el-icon-question"/>
            </el-popover>
          </div>
          <router-link to="/dashboard/tech" class="link-cont">
            <span>
              Техника
            </span>
            <i class="fas fa-chevron-right"></i>
          </router-link>
        </div>

        <div class="edit-li">
          <router-link to="/dashboard/documentation/edit" class="link-cont">
            <span>
              Документация
            </span>
            <i class="fas fa-chevron-right"></i>
          </router-link>
        </div>

        <div class="edit-li" v-if="this.$store.state.project.tasks">
          <router-link to="/dashboard/tasks/categories" class="link-cont">
            <span>
              Категории задач
            </span>
            <i class="fas fa-chevron-right"></i>
          </router-link>
        </div>

        <router-link
          :to="`/dashboard/unit`"
          class="edit-li"
        >
          Единицы измерения <i class="fas fa-chevron-right"></i>
        </router-link>

      </div>
      <div v-if="role === 'admin'" style="width: 100%; display: flex; align-items: flex-start; flex-direction: column">
        <strong>Доступные общие отчеты</strong>
        <div class="edit-ul checkbox-ul">
          <div
            class="edit-li"
          >
            Отчеты по работам
            <el-checkbox @change="save" v-model="available_reports.JOB"></el-checkbox>
          </div>
          <div
            class="edit-li"
          >
            Отчеты по технике
            <el-checkbox @change="save" v-model="available_reports.TECH"></el-checkbox>
          </div>
          <div
            class="edit-li"
          >
            Отчеты по численности
            <el-checkbox @change="save" v-model="available_reports.PROF"></el-checkbox>
          </div>
        </div>
      </div>

      <div v-if="role === 'admin'" style="width: 100%; display: flex; align-items: flex-start; flex-direction: column">
        <strong>Общие настройки</strong>
        <div class="edit-ul checkbox-ul">
          <div
            class="edit-li"
          >
            Задачи
            <el-checkbox @change="save" v-model="form.tasks"></el-checkbox>
          </div>
          <div
            class="edit-li"
          >
            Учет сроков
            <el-checkbox @change="save" v-model="form.deadline_accounting"></el-checkbox>
          </div>
          <div
            class="edit-li"
          >
            Показывать прогресс в аналитике
            <el-checkbox @change="save" v-model="form.progress"></el-checkbox>
          </div>
          <div
            class="edit-li"
          >
            Учет стоимости
            <el-checkbox @change="save" v-model="form.price"></el-checkbox>
          </div>
          <div
            class="edit-li"
          >
            Суточный план
            <el-checkbox @change="save" v-model="form.daily_plan"></el-checkbox>
          </div>
        </div>
      </div>
      <div class="edit-ul edit-ul-next">
        <router-link
          :to="`/dashboard/work_section`"
          class="edit-li"
        >
          <strong>
            Настройки по разделам работ</strong> <i class="fas fa-chevron-right"></i>
        </router-link>
      </div>
    </div>
    <el-form class="settings-form" v-if="role === 'admin'">
      <el-form-item label="Название проекта">
        <el-input v-model="form.name" placeholder/>
      </el-form-item>
      <el-form-item label="Адрес проекта">
        <el-input v-model="form.address"/>
      </el-form-item>
      <el-form-item label="Описание  проекта">
        <el-input v-model="form.description" type="textarea" textarea/>
      </el-form-item>
      <div v-if="this.$store.state.project.deadline_accounting">
        <el-form-item label="Директивный срок начала проекта">
          <div style="margin-left: -70px">
          <el-date-picker
            :editable="false"
            @input="changeDate"
            format="yyyy-MM-dd"
            v-model="form.start_date"
            type="date"
            placeholder="Укажите дату"
          >
          </el-date-picker>
          </div>
        </el-form-item>
        <el-form-item label="Директивный срок окончания проекта">
          <div style="margin-left: -70px">
            <el-date-picker
              @input="changeDate"
              :editable="false"
              format="yyyy-MM-dd"
              v-model="form.end_date"
              type="date"
              placeholder="Укажите дату"
            >
            </el-date-picker>
          </div>
        </el-form-item>
      </div>
      <div class="footer-edit">
        <el-button @click="save" type="primary">Сохранить</el-button>
      </div>


      <div class="delete-project">
        <el-button type="danger" plain @click="deleteProject">Удалить проект</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
import firebase from 'firebase';
import dayjs from "dayjs";

export default {
  name: 'SettingsView',
  data() {
    return {
      form: {
        start_date: null,
        end_date: null,
        name: '',
        address: '',
        description: '',
        progress: false,
        deadline_accounting: false,
        daily_plan: false,
        price: false,
        tasks: false,
      },
      role: 'admin',
      available_reports: {
        JOB: true,
        TECH: true,
        PROF: true,
        COVID: true,
      },
    };
  },

  mounted() {
    firebase.firestore()
      .collection('projects')
      .doc(this.$store.state.project.id).get().then((sub) => {
      const data = sub.data();
      if (data) {
        const rules = data.rules;
        if (rules) {
          this.role = rules[firebase.auth().currentUser.uid];

          if (data.isDemo) {
            this.role = 'admin';
          }
          this.loading = false;
        }
      }
    });
    const {name, address, start_date, end_date, description, tasks, progress, deadline_accounting, available_reports, daily_plan, price} = this.$store.state.project;
    this.form = {
      start_date, end_date,
      name, address, description,
      progress: progress || false,
      daily_plan: daily_plan || false,
      price: price || false,
      tasks: tasks || false,
      deadline_accounting: deadline_accounting || false,
    };
    if (this.available_reports) {
      this.available_reports = {
        ...this.available_reports,
        ...available_reports,
      };
    }
  },

  methods: {
    changeDate() {
      const s = '' + this.form.start_date;
      const e = '' + this.form.end_date;

      const start = dayjs(s).unix();
      const end = dayjs(e).unix();

      if (start && end && start > end) {
        this.form.start_date = null;
        this.$notify.error({title: 'Ошибка', message: 'Дата начала должна быть не позднее даты окончания'});
      }
    },
    deleteProject() {
      this.$confirm(`Вы действительно хотите удалить проект?`,
        `При удалении проекта вся информация будет удалена без возможности востановления`, {
          confirmButtonText: 'Да',
          cancelButtonText: 'Нет',
          type: 'warning',
        }).then(() => {
        firebase.firestore()
          .collection('projects')
          .doc(this.$store.state.project.id)
          .delete()
          .then((data) => {
            localStorage.removeItem('projectId');
            window.location.href = '/';
          });
      });
    },
    save() {
      console.log(this.form, 'this.form');
      firebase.firestore()
        .collection('projects')
        .doc(this.$store.state.project.id)
        .update({
          ...this.form,
          start_date: this.form.start_date ? dayjs(this.form.start_date).format('YYYY-MM-DD') : null,
          end_date: this.form.end_date ? dayjs(this.form.end_date).format('YYYY-MM-DD') : null,
          available_reports: this.available_reports,
        }).then(() => {
        this.$notify({
          offset: 60,

          title: 'Успешно!',
          message: 'Сохранено',
          type: 'success',
        });
        this.$store.dispatch('setProject', {
          ...this.form,
          start_date: this.form.start_date ? dayjs(this.form.start_date).format('YYYY-MM-DD') : null,
          end_date: this.form.end_date ? dayjs(this.form.end_date).format('YYYY-MM-DD') : null,
          available_reports: this.available_reports,
          id: this.$store.state.project.id,
        });
      })
        .catch((error) => console.error(error));
    }
    ,
  },
}
;
</script>

<style scoped lang="scss">
.settings-view {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 30px;
  max-width: 600px;
  margin: 0 auto;
  padding-bottom: 40px;

  .settings-form {
    max-width: 600px;
    width: calc(100% - 40px);
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    > > > .el-form-item {
      width: 100%;
    }
  }

  .footer-edit {
    display: flex;
    justify-content: space-between;
    margin-bottom: 32px;
  }
}

.edit-li {
  display: flex;
  justify-content: space-between;
  height: 40px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.18);
  cursor: pointer;
  align-items: center;
  padding: 0 10px;
  text-decoration: none;
  color: #606266;

  span:first-child {
    margin-right: 20px;
  }

  span {
    margin-right: 5px;
  }

  &:last-child {
    border-bottom: none;
  }

  &:hover {
    background: #f5f5f5;
  }
}

.checkbox-ul {
  .edit-li {
    &:hover {
      background: #fff
    }
  }
}

.edit-ul {
  width: calc(100% - 20px);
  display: flex;
  flex-direction: column;
  margin-top: 20px;
  margin-bottom: 40px;
}

.menu-settings {
  display: flex;
  align-items: flex-start;
  width: calc(100% - 40px);
  flex-direction: column;
  margin-bottom: 40px;
}

.edit-ul-next {
  margin-top: 0px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.18);
  border-top: 1px solid rgba(0, 0, 0, 0.18);
}

.delete-project {
  margin-top: 80px;
  width: 100%;
  display: flex;
  justify-content: flex-end;
}

.section-li {
  display: flex;
}

.link-cont {
  display: flex;
  justify-content: space-between;
  color: #606266;
  text-decoration: none;
  flex: 1;
}

.help-container {
  width: 32px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
<style>
.el-popover {
  text-align: unset !important;
  word-break: unset !important;
}
</style>



// WEBPACK FOOTER //
// src/views/Dashboard/Projects/Edit.vue